import { DispatchConfig, IClientConfigurationService } from '@workbench-stack/core';

export function getDispatchConfig(configurationService: IClientConfigurationService): DispatchConfig {
    const keyboard = configurationService.getValue('keyboard');
    const r = (keyboard ? (<any>keyboard).dispatch : null);
    return (r === 'keyCode' ? DispatchConfig.KeyCode : DispatchConfig.Code);
}
